<template>
  <div>
    <div v-for="(category, index) in categoryList" :key="'cate_' + index">
      <div v-bind:class="{cetegory_item: true, active: category.id === selCategoryNo}" @click="selectCategory(category)">
        <div>
          <img :src="categoryImgBlack(category.img)" v-if="category.id !== selCategoryNo">
          <img :src="categoryImgWhite(category.img)" v-else>
        </div>
        <div>{{category.name}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import {DC_URL} from '../../../constants/App'

export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      categoryList: [],
      selCategoryNo: 1
    }
  },
  computed: {
  },
  methods: {
    getCategoryList: function () {
      axios.get(DC_URL.TOP + '/category')
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          }
          this.categoryList = response.data.data
        }).catch(error => {
          Api.handleError(error)
        }).finally(() => {
          // this.$refs.loadingModalRef.showModal(false)
        })
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    categoryImgBlack: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_black' + exp)
    },
    categoryImgWhite: function (imgName) {
      if (!imgName) return undefined
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return this.getImage('category/' + file + '_white' + exp)
    },
    selectCategory: function (category) {
      this.selCategoryNo = category.id
    }
  },
  mounted: function () {
    this.getCategoryList()
    this.selCategoryNo = 1
  },
  created: function () {
  }
}
</script>
<style src="../../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/DcCategoryList.vue